export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * Generic retry function of async operations depending on errors
 * @param task the call that should be made
 * @param attempts how many attempts
 * @param interval how much time between calls
 * @param shouldRetry a test that can check if a retry attempt should be done depending on the error
 */
export async function asyncRetry<T>(
  task: () => Promise<T>,
  attempts: number,
  interval: number,
  shouldRetry?: (error: Error) => boolean
): Promise<T> {
  try {
    const result = await task()
    return result
  } catch (err) {
    const retry = shouldRetry ? shouldRetry(err) : true
    if (retry && attempts > 0) {
      await sleep(interval)
      return asyncRetry(task, attempts - 1, interval, shouldRetry)
    } else {
      throw err
    }
  }
}

export default {
  asyncRetry,
  sleep,
}
